import { IWaterWell } from '../../interfaces/iwater-well';
import { Area } from '../area';
import { Asset } from '../asset';
import { AssetTeam } from '../asset-team';
import { LifespanProjection } from '../lifespan-projection';
import { PowerSourceType } from '../power-source-type';
import { Rig } from '../rig';
import { SCADAType } from '../s-c-a-d-a-type';
import { WellScreenType } from '../well-screen-type';

export class WaterWellBase {
  WaterWellId: number;
  SSN: string;
  Name: string | null;
  AssetTeamId: number;
  AreaId: number | null;
  RigId: number | null;
  WaterTypeID: number | null;
  WaterCompletionTypeId: number | null;
  WellScreenTypeId: number | null;
  SCADAWell: boolean;
  SCADATypeId: number | null;
  LifespanProjectionId: number | null;
  Comments: string | null;
  ElectricalControlBoxModelId: number | null;
  PowerSourceTypeId: number | null;
  PowerSourceLastDateChecked: Date | null;
  Archive: boolean;
  AssetId: number | null;
  GeoCenter: object | null;
  TargetDepth: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Area?: Area;
  Asset?: Asset;
  AssetTeam?: AssetTeam;
  LifespanProjection?: LifespanProjection;
  Rig?: Rig;
  SCADAType?: SCADAType;
  WellScreenType?: WellScreenType;
  PowerSourceType?: PowerSourceType;

  constructor(item?: IWaterWell) {
    if (item) {

      this.WaterWellId = item.WaterWellId;
      this.SSN = item.SSN;
      this.Name = item.Name;
      this.AssetTeamId = item.AssetTeamId;
      this.AreaId = item.AreaId;
      this.RigId = item.RigId;
      this.WaterTypeID = item.WaterTypeID;
      this.WaterCompletionTypeId = item.WaterCompletionTypeId;
      this.WellScreenTypeId = item.WellScreenTypeId;
      this.SCADAWell = item.SCADAWell;
      this.SCADATypeId = item.SCADATypeId;
      this.LifespanProjectionId = item.LifespanProjectionId;
      this.Comments = item.Comments;
      this.ElectricalControlBoxModelId = item.ElectricalControlBoxModelId;
      this.PowerSourceTypeId = item.PowerSourceTypeId;
      this.PowerSourceLastDateChecked = item.PowerSourceLastDateChecked ? new Date(item.PowerSourceLastDateChecked) : null;
      this.Archive = item.Archive;
      this.AssetId = item.AssetId;
      this.GeoCenter = item.GeoCenter;
      this.TargetDepth = item.TargetDepth;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Area = new Area(item.Area);
      this.Asset = new Asset(item.Asset);
      this.AssetTeam = new AssetTeam(item.AssetTeam);
      this.LifespanProjection = new LifespanProjection(item.LifespanProjection);
      this.Rig = new Rig(item.Rig);
      this.SCADAType = new SCADAType(item.SCADAType);
      this.WellScreenType = new WellScreenType(item.WellScreenType);
      this.PowerSourceType = new PowerSourceType(item.PowerSourceType);
    }
  }
}